// extracted by mini-css-extract-plugin
export default {"contact_wrapper":"ContactWrapper_contact_wrapper__u2s-I"};